/**
 * @file        src/data/gallery.js
 * @description Shared image gallery (Unsplash URLs) referenced by hotels & rooms.
 *              Ported verbatim from /Neon Bookign site Design/.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */

export const GAL = [
  'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=900&q=80',
  'https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1618773928121-c32242e63f39?auto=format&fit=crop&w=600&q=80',
  'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=600&q=80',
];
